import {NirComponent} from "../nir/nir.component";
import {Nir} from "../nir/nir";
export class Patient {
  public nir: Nir = new Nir();
  public isALD: boolean = false;
  public isATMP: boolean = false;
  public birthday: string = "";
  public rang: string = "1";
  public regime: string = "01";
  public realisationDate: string = "";
  public prescriptionDate: string = "";
  public pec100: boolean = false;
  public atDate: string = "";
  public atID: string = "";
  public isL115: boolean = false;

  public isCompleted(){
    return this.nir.isValid()
      && this.birthday != ""
      && this.rang != ""
      && this.regime != ""
      && ((this.isATMP && (this.atDate != "" || this.atID != "")) || !this.isATMP)
      && this.realisationDate != ""
      && this.prescriptionDate != ""
      ;
  }

  public static create(datas: any){
    let patient = new Patient();

    if (datas.birthday){
      patient.birthday = datas.birthday;
    }
    if (datas.row){
      patient.rang = datas.row;
    }
    if (datas.social.grandRegime){
      patient.regime = datas.social.grandRegime;
    }

    if (datas.nir){
      if (datas.nir.num && datas.nir.key){
        patient.nir = new Nir(datas.nir.num, datas.nir.key)
      }
    }

    if (datas.prescription){
      if (datas.prescription.date){
        patient.prescriptionDate = datas.prescription.date;
      }
      if (datas.prescription.transport){

        if (datas.prescription.transport.custom){
          if (datas.prescription.transport.custom.date){
            patient.realisationDate = datas.prescription.transport.custom.date;
          }
          if (datas.prescription.transport.custom.dateATMP){
            patient.atDate = datas.prescription.transport.custom.dateATMP;
            patient.isATMP = true;
          }
          if (datas.prescription.transport.custom["identifiant_at"]){
            patient.atID = datas.prescription.transport.custom["identifiant_at"];
            patient.isATMP = true;
          }
          if (datas.prescription.transport.custom.motifs){
            for (let k = 0; k < datas.prescription.transport.custom.motifs.length; ++k){
              if (datas.prescription.transport.custom.motifs[k] == "ALD"){
                patient.isALD = true;
              }
              if (datas.prescription.transport.custom.motifs[k] == "CDP100"){
                patient.pec100 = true;
              }
            }
          }
        }
      }
    }

    return patient;
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/patient.ts